import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { actions as appActions } from '~/redux/reducers/app';
import { Typo, Icon, Container } from 'tmt-ui-kit';


const Banner = styled.div`
  position: fixed;
  bottom: 0;
  z-index: 4000;  
  width: 100%;
  height: ${props => (props.isGDPR ? '38px' : '0px')};
  background: ${props => props.theme.darkBlue};
  transition: all 0.5s ease-in-out;
  overflow: hidden;

  @media only screen and (max-width: 931px){
    padding: ${props => (props.isGDPR && '8px')} 0;
    height: ${props => (props.isGDPR ? '60px' : '0px')};    
  }
  @media only screen and (max-width: 514px){
    height: ${props => (props.isGDPR ? '80px' : '0px')};
    
  }
  @media only screen and (max-width: 356px){
    height: ${props => (props.isGDPR ? '100px' : '0px')};
  }
`;

const BlogText = styled(Container.InnerContainer)`
  height: 100%;
  display: flex;
  max-width: 1900px;
  justify-content: space-between;
  align-items: center;
  color: ${props => props.theme.white};

  @media only screen and (max-width: 1900px){
    max-width: initial;
  }

  @media only screen and (max-width: 931px){
    align-items: flex-start;
  }
  @media only screen and (max-width: 514px){
    height: 60px;
  }
`;

const Text = styled(Typo.Paragraph)`
  margin: 0;
  color: ${props => props.theme.white} !important;
`;

const TextLink = styled.a`
  text-decoration: underline;
  color: ${props => props.theme.white} !important;
`;

const IconClose = styled(Icon)`
  cursor: pointer;
  @media only screen and (max-width: 600px){
    padding-left: 0px;
  }
`;

const enhance = connect(
  state => ({
    isGDPR: state.app.isGDPR
  }),
  {
    ...appActions,
  }
);

class GdprBanner extends Component {
  static propTypes = {
    isGDPR: PropTypes.bool,
    setShowGDPR: PropTypes.func,
  }

  shouldComponentUpdate(nextProps) {
    if (this.props.isGDPR !== nextProps.isGDPR) {
      return true;
    }
    return false;
  }

  onCloseGdpr = () => {
    window.requestAnimationFrame(() => {
      document.cookie = 'is_close_gdpr=true; path=/;expires=Fri, 31 Dec 9999 23:59:59 GMT';
      this.props.setShowGDPR(false);
    });
  }

  render() {
    return (
      <Banner isGDPR={this.props.isGDPR}>
        <BlogText>
          <Text>Cookies help us provide better services and protect your data. By continuing to use our site, you agree to our <TextLink href="https://www.takemetour.com/article/cookie-policy" target="_blank" rel="noopener noreferrer">cookie policy</TextLink></Text>
          <IconClose onClick={this.onCloseGdpr} name="close"/>
        </BlogText>
      </Banner>
    );
  }
}

export default enhance(GdprBanner);
